import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreatePromocodeBatchMutation } from "@modules/promocodeBatches/services/mutations";
import { PromocodeBatchFormValues, promocodeBatchSchema } from "@modules/promocodeBatches/validations";
import { listPromocodeBatchesQueryKey } from "@modules/promocodeBatches/services/queries";
import { CreatePromocodeBatchModalProps } from "./types";

export function useCreatePromocodeBatchModal({ modalRef, onComplete }: CreatePromocodeBatchModalProps) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<PromocodeBatchFormValues>({
    resolver: zodResolver(promocodeBatchSchema()),
    defaultValues: {
      active: true,
    },
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreatePromocodeBatchMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listPromocodeBatchesQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("promocode_batch_admin.success.create"),
      });

      onComplete();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
